module.exports = __webpack_public_path__ + "static/img/Lxzk7000.2e8105de.png";